export var AdBreakEventStatus = /*#__PURE__*/ function(AdBreakEventStatus) {
    AdBreakEventStatus["NEW_BREAK"] = "NEW_BREAK";
    AdBreakEventStatus["ACTIVE_BREAK"] = "ACTIVE_BREAK";
    AdBreakEventStatus["UPDATED_BREAK"] = "UPDATED_BREAK";
    return AdBreakEventStatus;
}({});
export var AdTransitionType = /*#__PURE__*/ function(AdTransitionType) {
    AdTransitionType["Start"] = "Start";
    AdTransitionType["End"] = "End";
    return AdTransitionType;
}({});

//# sourceMappingURL=bolt-ons.enums.js.map